import type { ReactNode } from 'react';
import { UMIcon } from '../../urbanmap/_components';
import { UMR } from './planTokens';

/** Copie inchangée de l'état vide utilisé par la V3 (`page-accueil/HomeCards`). */
export function EmptyState({ icon, title, children }: { icon: string; title: string; children?: ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, padding: '64px 24px', border: `1px dashed ${UMR.border}`, color: UMR.textSecondary, textAlign: 'center' }}>
      <UMIcon name={icon} size={40} color={UMR.textSecondary} />
      <div style={{ fontSize: 18, fontWeight: 700, color: UMR.textStrong }}>{title}</div>
      {children}
    </div>
  );
}
